import { Badge } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function RulesFormatter({ info }) {
  const { value } = getInfo(info)
  return <Badge variant='outline' color={value ? 'accent' : 'danger'}>
    {value ? 'active' : 'inactive'}
  </Badge>
}
